export default class MoreInfo {
	constructor(moreInfoExpandable) {
		// this.moreInfoButtonitem = item;
		if (moreInfoExpandable) {
			this._init(moreInfoExpandable);
		}
	}

	_init(moreInfoExpandable) {
		for (let i = 0; i < moreInfoExpandable.length; i++) {
			let item = moreInfoExpandable[i];
			item.addEventListener('click', () => {
				// console.log('item', item);
				// console.log('item classlist', item.classList);
				if (!item.classList.contains('more-info')) {
					return;
				}

				if (
					item.previousElementSibling != null &&
					item.previousElementSibling != undefined
				) {
					item.previousElementSibling.classList.toggle(
						'design-section__hide-text'
					);

					if (
						window.innerWidth < 960 &&
						!document.querySelector('.design-section-block') &&
						!document.querySelector('.design-section-start-page') &&
						!document.querySelector('.news-page-wrapper')
					) {
						item.previousElementSibling.classList.toggle(
							'small-screen-page-hide-preamble-text'
						);
						item.previousElementSibling.classList.remove(
							'design-section__hide-text'
						);
					}

					if (
						(item.previousElementSibling.classList.contains(
							'design-section__hide-text'
						) &&
							item.classList.contains('more-info')) ||
						(item.previousElementSibling.classList.contains(
							'small-screen-page-hide-preamble-text'
						) &&
							item.classList.contains('more-info') &&
							!document.querySelector('.design-section-block') &&
							!document.querySelector('.design-section-start-page') &&
							!document.querySelector('.news-page-wrapper'))
					) {
						item.innerHTML = 'MORE INFO';
					} else if (item.classList.contains('more-info')) {
						item.innerHTML = 'LESS INFO';
					}
				}
			});
		}
	}
}
